// extracted by mini-css-extract-plugin
module.exports = {"root":"ReplayButton_root__31jqz","icon":"ReplayButton_icon__tNIae","label":"ReplayButton_label__1007h"};